// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"53":"16a8e0b2","568":"33bdeb08","615":"8b01e46f","877":"a40e2501"}[chunkId] + ".js";
};